function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { ReactNode, MouseEventHandler, FC, Ref, ButtonHTMLAttributes, AnchorHTMLAttributes, LabelHTMLAttributes, ComponentType } from 'react';
import cn from 'classnames';
require("./ClickableBase.css");
var styles = {
  "Root": "ClickableBase-module-Root_10t"
};
export const ClickableBase = ({
  'aria-selected': ariaSelected,
  'data-selected': dataSelected,
  children,
  className,
  controlRef,
  disabled,
  innerRef,
  onClick,
  rel,
  tabIndex = 0,
  tag = 'button',
  target = '_self',
  to
}) => {
  let RootTag = tag;
  const rootProps = {
    ...(disabled && tag !== 'button' && {
      'aria-disabled': true
    })
  };
  if (tag === 'button') {
    rootProps.type = 'button';
    rootProps.disabled = disabled;
  }
  if (onClick) rootProps.onClick = onClick;
  if (tag === 'a' || to) {
    rootProps.href = !disabled ? to : undefined;
    rootProps.type = undefined;
    rootProps.target = target;
    RootTag = 'a';
  }
  if (tag === 'label') {
    RootTag = 'label';
  }
  return /*#__PURE__*/React.createElement(RootTag, _extends({
    "aria-selected": ariaSelected,
    className: cn(styles.Root, className),
    "data-selected": dataSelected,
    ref: innerRef || controlRef,
    rel: rel,
    tabIndex: disabled ? -1 : tabIndex
  }, rootProps), children);
};
if (process.env.NODE_ENV !== 'production') {
  ClickableBase.displayName = 'ClickableBase';
}